'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';
import {Button} from '../../buttons/Button';


export function ListDividerView(props) {
  return (
    <div
      className={classNames("ListDivider", props.className, {
        ListDivider__active: props.isToggled,
      })}
    >
      <div className="ListDivider__leftSide">
        {props.showFilter ? (
          <Button
            className="ListDivider__visibilityButton"
            title={props.isToggled ? props.iconShowTitle : props.iconHideTitle}
            label={props.isToggled ? '+' : '—'}
            bindParam={props.bindParam}
            onClick={props.onClickToggle}
          />
        ) : null}
        <span className="ListDivider__name">
          {props.label}
        </span>
      </div>
      <div>
        {props.showOptions ? (
          <Button
            className="ListDivider__optionsButton"
            title={props.iconOptionsTitle}
            bindParam={props.bindParam}
            onClick={props.onClickOptions}
            iconClass="context-icon"
          />
        ) : null}
      </div>
    </div>
  );
}

ListDividerView.propTypes = {
  className: T.string,
  label: T.string,
  showFilter: T.bool,
  isToggled: T.bool,
  bindParam: T.any,
  onClickToggle: T.func,
  onClickOptions: T.func,

  iconShowTitle: T.string,
  iconHideTitle: T.string,
  iconOptionsTitle: T.string,
};

ListDividerView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/components/lists/ListDivider/ListDividerView.js